// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"c6ae25ec","3307":"c6ae25ec","4814":"c6ae25ec","7934":"c6ae25ec","8498":"c6ae25ec"}[chunkId] + ".chunk.css";
};